import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SwapSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SwapSVG;
